module.exports = "/resources/assets/prod/d56f3a2fc761cdf7640b7d6cf53a2595.svg";